import React from "react";
import "./Subordinate_Data.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Filter_Drop from "../Common/Common_Component/Filter_Drop/Filter_Drop";
import Subordinate_Data_card from "./Subordinate_Data_card/Subordinate_Data_card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Form, InputGroup } from "react-bootstrap";
import No_data from "../Common/No_data/No_data";

function Subordinate_Data() {
  return (
    <>
      <section className="Subordinate_Data">
        <Common_white_header headingText={"Subordinate Data"} />
        <div className="container">
          
          <div className="search_feild_holder  ">
            

          <InputGroup className="mb-3">
            <Form.Control
              placeholder="Search Subordinate UID"
            />
            <InputGroup.Text id="basic-addon2"><FontAwesomeIcon icon={faMagnifyingGlass} /></InputGroup.Text>
          </InputGroup>
          </div>
          
          <Filter_Drop />

          <div className="Rebate_Ratio_holder">
            <div className="row me-0 ms-0">
              <div className="col-6 border_col">
                <div className="text_holder">
                  <h3>0.19</h3>
                  <p>Deposit Number</p>
                </div>
              </div>

              <div className="col-6">
                <div className="text_holder">
                  <h3>657.52</h3>
                  <p>Deposit Amount</p>
                </div>
              </div>

              <div className="col-6 border_col">
                <div className="text_holder">
                  <h3>0.19</h3>
                  <p>Number of bettors</p>
                </div>
              </div>

              <div className="col-6">
                <div className="text_holder">
                  <h3>657.52</h3>
                  <p>Total bet</p>
                </div>
              </div>

              <div className="col-6 border_col">
                <div className="text_holder">
                  <h3>15</h3>
                  <p>Number of People making first deposit</p>
                </div>
              </div>

              <div className="col-6">
                <div className="text_holder">
                  <h3>0</h3>
                  <p>First Deposit amount</p>
                </div>
              </div>
            </div>
          </div>

          <Subordinate_Data_card />

           <No_data/>
        </div>
      </section>
    </>
  );
}

export default Subordinate_Data;
